import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Check, X, ExternalLink, AlertCircle } from 'lucide-react';
export function AdminDataVerificationPage() {
  return <div className="min-h-screen bg-background text-textMain flex flex-col" data-id="element-964">
      <header className="h-16 border-b border-border flex items-center justify-between px-6 bg-surface shrink-0" data-id="element-965">
        <div className="flex items-center gap-4" data-id="element-966">
          <span className="text-xl font-bold text-red-500" data-id="element-967">Booker Admin</span>
          <div className="w-px h-6 bg-border" data-id="element-968"></div>
          <nav className="flex items-center gap-4 text-sm font-medium" data-id="element-969">
            <Link to="/admin" className="text-textMuted hover:text-textMain" data-id="element-970">
              Dashboard
            </Link>
            <Link to="/admin/data-verification" className="text-textMain" data-id="element-971">
              Data Verification
            </Link>
          </nav>
        </div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex-1 p-8 max-w-7xl mx-auto w-full" data-id="element-972">
        <div className="mb-8" data-id="element-973">
          <h1 className="text-2xl font-bold mb-1" data-id="element-974">Data Verification Queue</h1>
          <p className="text-sm text-textMuted" data-id="element-975">
            Review imported or crawled venue/contact updates before committing
            to the global database.
          </p>
        </div>

        <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-976">
          <div className="p-4 border-b border-border bg-background/50 flex items-center justify-between" data-id="element-977">
            <div className="flex items-center gap-2" data-id="element-978">
              <span className="text-sm font-medium" data-id="element-979">Pending Reviews (3)</span>
            </div>
            <div className="flex gap-2" data-id="element-980">
              <button className="px-3 py-1.5 bg-green-500/10 text-green-500 rounded-lg text-sm font-medium hover:bg-green-500/20 transition-colors" data-id="element-981">
                Approve All
              </button>
              <button className="px-3 py-1.5 bg-red-500/10 text-red-500 rounded-lg text-sm font-medium hover:bg-red-500/20 transition-colors" data-id="element-982">
                Reject All
              </button>
            </div>
          </div>

          <div className="divide-y divide-border" data-id="element-983">
            {[{
            entity: 'The Empty Bottle',
            field: 'Capacity',
            old: '350',
            new: '400',
            source: 'Crawl (emptybottle.com/about)',
            confidence: 'High'
          }, {
            entity: 'Higher Ground',
            field: 'Booking Email',
            old: 'booking@higherground.com',
            new: 'talent@highergroundmusic.com',
            source: 'User Report',
            confidence: 'Medium'
          }, {
            entity: 'The Sinclair',
            field: 'Age Policy',
            old: '18+',
            new: '21+',
            source: 'Crawl (ticketmaster.com)',
            confidence: 'High'
          }].map((item, i) => <div key={i} className="p-6 hover:bg-surfaceHover/50 transition-colors" data-id="element-984">
                <div className="flex items-start justify-between gap-4 mb-4" data-id="element-985">
                  <div data-id="element-986">
                    <h3 className="font-bold text-lg" data-id="element-987">{item.entity}</h3>
                    <p className="text-sm text-textMuted" data-id="element-988">
                      Field: {item.field}
                    </p>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-989">
                    <button className="px-4 py-2 bg-green-500/10 text-green-500 rounded-lg text-sm font-medium hover:bg-green-500/20 transition-colors flex items-center gap-2" data-id="element-990">
                      <Check className="w-4 h-4" data-id="element-991" /> Accept
                    </button>
                    <button className="px-4 py-2 bg-red-500/10 text-red-500 rounded-lg text-sm font-medium hover:bg-red-500/20 transition-colors flex items-center gap-2" data-id="element-992">
                      <X className="w-4 h-4" data-id="element-993" /> Reject
                    </button>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-994">
                  <div className="bg-background border border-border rounded-lg p-4" data-id="element-995">
                    <div className="text-xs text-textMuted mb-1 uppercase tracking-wider font-semibold" data-id="element-996">
                      Current Value
                    </div>
                    <div className="font-medium text-red-500 line-through" data-id="element-997">
                      {item.old}
                    </div>
                  </div>
                  <div className="bg-background border border-primary/30 rounded-lg p-4 relative overflow-hidden" data-id="element-998">
                    <div className="absolute top-0 left-0 w-1 h-full bg-primary" data-id="element-999"></div>
                    <div className="text-xs text-primary mb-1 uppercase tracking-wider font-semibold" data-id="element-1000">
                      Proposed Value
                    </div>
                    <div className="font-medium text-green-500" data-id="element-1001">{item.new}</div>
                  </div>
                  <div className="bg-background border border-border rounded-lg p-4" data-id="element-1002">
                    <div className="text-xs text-textMuted mb-1 uppercase tracking-wider font-semibold" data-id="element-1003">
                      Source & Proof
                    </div>
                    <div className="font-medium flex items-center gap-2 text-sm" data-id="element-1004">
                      {item.source}{' '}
                      <ExternalLink className="w-3 h-3 text-primary cursor-pointer" data-id="element-1005" />
                    </div>
                    <div className="mt-2 flex items-center gap-1" data-id="element-1006">
                      <AlertCircle className={`w-3 h-3 ${item.confidence === 'High' ? 'text-green-500' : 'text-amber-500'}`} data-id="element-1007" />
                      <span className={`text-xs ${item.confidence === 'High' ? 'text-green-500' : 'text-amber-500'}`} data-id="element-1008">
                        {item.confidence} Confidence
                      </span>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </motion.div>
    </div>;
}